import { Checkbox } from "@/shared/components/ui/checkbox";
import { CheckedState } from "@radix-ui/react-checkbox";
import { useToast } from "@/shared/hooks/use-toast";
import { parseRTKQueryError } from "@/shared/components/errors/parse-r-t-k-query-error";
import {
  useHtzVisualAssessmentCatalogPutActiveCatalogMutation,
  useHtzVisualAssessmentCatalogShowActiveCatalogQuery,
} from "@/services/backend/htz/inspection/api/visual-assessment-catalog-api";

export interface ActiveVisualAssessmentCatalogCheckboxProps {
  companyId: string;
  catalogId: string;
}

export function ActiveVisualAssessmentCatalogCheckbox({
  companyId,
  catalogId,
}: ActiveVisualAssessmentCatalogCheckboxProps) {
  const { data: activeCatalog } =
    useHtzVisualAssessmentCatalogShowActiveCatalogQuery({ companyId });

  const [put, { isLoading, error, reset }] =
    useHtzVisualAssessmentCatalogPutActiveCatalogMutation();

  const { toast } = useToast();

  if (error) {
    toast({
      ...parseRTKQueryError(error),
      variant: "destructive",
    });
    reset();
  }

  if (!activeCatalog) {
    return null;
  }

  const checked = activeCatalog.catalogId === catalogId;
  const onCheckedChange = (newState: CheckedState) => {
    if (isLoading) {
      return;
    }

    switch (newState) {
      case true:
        put({ companyId, catalogId });
        break;
      case false:
        put({ companyId, catalogId: null });
        break;
      case "indeterminate":
        break;
      default:
        break;
    }
  };

  return (
    <Checkbox
      checked={checked}
      onCheckedChange={onCheckedChange}
      className={isLoading ? "animate-pulse" : ""}
      disabled={isLoading}
    />
  );
}
